import { createRequest } from "helpers/tools";

export const getMondayURL = async () => {
    return await createRequest({
        suffix: `monday/auth-url`,
        handleError: true,
        method: "get",
    });
};

export const mondayStore = async (data) => {
    return await createRequest({
        suffix: "monday",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const mondayUpdate = async (data, id) => {
    return await createRequest({
        suffix: `monday/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const mondayTest = async (id) => {
    return await createRequest({
        suffix: `monday/${id}/preview`,
        method: "get",
        handleError: false,
    });
};

export const mondayFields = async (id) => {
    return await createRequest({
        suffix: `monday/${id}/fields`,
        method: "get",
        handleError: false,
    });
};
